module.exports = __webpack_public_path__ + "img/rural-banner3.bcb3b47b.jpg";